import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import VisuallyHidden from '../../VisuallyHidden/VisuallyHidden';
import { FieldArray } from 'formik';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function TimesField(props) {
  const { classes, fieldName, preferredTimes, value, label } = props;

  return (
    <div className={classes.root}>
      <Grid container>
        <FieldArray
          name={fieldName}
          render={(arrayHelpers) => (
            <React.Fragment>
              <Grid item xs={2} className={classes.availabilityRow}>
                <Typography variant="body1">{label}</Typography>
              </Grid>
              {preferredTimes.map((time, i) => (
                <Grid item xs={2} key={i} className={classes.availabilityRow}>
                  <div key={time.id}>
                    <label>
                      <Checkbox
                        name={fieldName}
                        value={time.id}
                        checked={value.includes(time.id)}
                        onChange={(e) => {
                          if (e.target.checked) arrayHelpers.push(time.id);
                          else {
                            const idx = value.indexOf(time.id);
                            arrayHelpers.remove(idx);
                          }
                        }}
                      />{' '}
                      <VisuallyHidden
                        body={<Typography>{time.name}</Typography>}
                      />
                    </label>
                  </div>
                </Grid>
              ))}
            </React.Fragment>
          )}
        />
      </Grid>
    </div>
  );
}

TimesField.propTypes = {
  classes: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  preferredTimes: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(TimesField);
